import React from "react";
import EmployerHome from "../../components/Employer/Home/EmployerHome";

const EmployerHomePage = () => {
  return (
    <div>
      <EmployerHome />
    </div>
  );
};

export default EmployerHomePage;
